import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    borderRadius: 5,
    borderWidth: 1,
    borderStyle: 'solid',
    display: 'flex',
    height: 80,
    justifyContent: 'space-between',
    padding: '15px 16px',
    width: '100%',
    '@media (max-width:960px)': {
      justifyContent: 'space-between',
      paddingLeft: '10%',
      paddingRight: '10%',
    },
  },

  data: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    maxWidth: 200,
    justifyContent: 'space-evenly',

    '&.lateReturn': {
      width: 'auto',
    },
  },

  widgetIcon: {
    color: '#FFF',
    fontSize: 40,
    borderRadius: '50%',
    padding: 8,
    display: 'flex',
    background: `#0176E8 0% 0% no-repeat padding-box`,
    '@media (max-width:1460px)': {
      '& svg': {
        fontSize: 20,
      },
    },
  },

  primary: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },

  warning: {
    borderColor: theme.palette.warning.main,
    color: theme.palette.warning.main,
  },

  error: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
  },

  success: {
    borderColor: theme.palette.success.main,
    color: theme.palette.success.main,
  },

  primaryIcon: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },

  warningIcon: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
  },

  errorIcon: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },

  successIcon: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },

  widgetContent: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 16,
  },

  widgetValue: {
    color: theme.palette.secondary.dark,
    fontSize: 24,
    fontWeight: 'bold',
  },

  widgetLabel: {
    color: theme.palette.secondary.dark,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
  },

  showButton: {
    alignItems: 'flex-end',
    color: theme.palette.secondary.dark,
    cursor: 'pointer',
    display: 'flex',
    fontSize: theme.typography.pxToRem(12),
    height: '100%',
    marginBottom: -3,
  },

  showButtonLabel: {
    color: theme.palette.secondary.dark,
    fontSize: theme.typography.pxToRem(12),
  },

  showButtonIcon: {
    fontSize: theme.typography.pxToRem(12),
  },
}));

export default useStyles;
